import { render, staticRenderFns } from "./ValuesBlock.vue?vue&type=template&id=66d3270b&scoped=true&"
import script from "./ValuesBlock.vue?vue&type=script&lang=js&"
export * from "./ValuesBlock.vue?vue&type=script&lang=js&"
import style0 from "./ValuesBlock.vue?vue&type=style&index=0&id=66d3270b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d3270b",
  null
  
)

export default component.exports